<template>
  <div>
    <gmap-autocomplete
      :placeholder="autocompletePlaceholder || ''"
      class="gmaps-autocomplete"
      @place_changed="setPlace"
    />
    <gmap-map class="mb-2" :center="center" :zoom="12" @click="mapClicked" style="width:100%;  height: 400px">
      <gmap-info-window
        :opened="openInfoWindow"
        :position="draggedTo || marker.position"
        @closeclick="openInfoWindow=false"
        :options="{
          pixelOffset: {
            width: 0,
            height: -42
          }
        }"
      >
        <div v-if="draggedToAddress" style="padding:10px;">
          <h6>{{ draggedToAddress.formatted_address }}</h6>
          <div class="text-right">
            <button
            class="btn btn-primary"
            style="border-radius: 50px; margin-top:5px;"
            @click="usePosition"
          >Use This Location</button>
          </div>
        </div>
        <div v-else style="padding:10px;"> Please search location or drag the marker </div>
      </gmap-info-window>
      <gmap-marker
        :draggable="true"
        :position="marker.position"
        :clickable="true"
        @drag="dragged"
        @click="openInfoWindow = true"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>
<script>
export default {
  props: {
    initial_address: {
      type: String
    },
    autocompletePlaceholder: {
      type: String
    },
    longtitude: {
      type: [Number, Boolean],
      default: 153.0271039
    },
    latitude: {
      type: [Number, Boolean],
      default: -27.4732453
    }
  },
  watch: {
    longtitude(lng) {
      this.center = {
        lat: this.lat,
        lng: lng
      }
      this.position = {
        lat: this.lat,
        lng: lng
      }
    },
    latitude(lat) {
      this.center = {
        lat: lat,
        lng: this.lng
      }
      this.position = {
        lat: lat,
        lng: this.lng
      }
    }
  },
  computed: {
    marker() {
      return {
        position: this.position
      };
    },
    position: {
      get: function() {
        return {
          lat: this.lat,
          lng: this.lng
        };
      },
      set: function(position) {
        this.lat = position.lat;
        this.lng = position.lng;
      }
    }
  },
  data() {
    return {
      lat: this.latitude,
      lng: this.longtitude,
      dragTimeout: null,
      searchedPlace: null,
      openInfoWindow: false,
      draggedToAddress: null,
      draggedTo: null,
      center: {
        lat: this.latitude,
        lng: this.longtitude
      }
    };
  },
  mounted() {
    this.reverseGeocode();
  },
  methods: {
    setPlace(place) {
      this.searchedPlace = place;
      this.position = {
        lat: this.searchedPlace.geometry.location.lat(),
        lng: this.searchedPlace.geometry.location.lng()
      };
      this.center = this.position;
      this.marker.position = this.position;
      this.draggedTo = this.position;
      this.draggedToAddress = this.searchedPlace;
    },
    dragged(value) {
      this.openInfoWindow = true;
      let lat = value.latLng.lat();
      let lng = value.latLng.lng();
      this.position = { lat, lng };
      this.draggedTo = this.position;
      if (this.dragTimeout) clearTimeout(this.dragTimeout);
      this.dragTimeout = setTimeout(() => {
        this.reverseGeocode();
      }, 100);
    },
    mapClicked(value) {
      
      this.openInfoWindow = true;
      this.position = {
        lat: value.latLng.lat(),
        lng: value.latLng.lng()
      };
      this.center = this.position;
      this.marker.position = this.position;
      this.draggedTo = this.position;
      if (this.dragTimeout) clearTimeout(this.dragTimeout);
      this.dragTimeout = setTimeout(() => {
        this.reverseGeocode();
      }, 100)
      this.openInfoWindow = true;
    },
    usePosition() {
      this.$emit("dropped-pin", {
        location: this.position,
        google_address: this.draggedToAddress
      });
      this.center = this.position;
      this.openInfoWindow = false;
    },
    reverseGeocode() {
      this.$gmapApiPromiseLazy().then(() => {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ location: this.position }, (results, status) => {
          if (status == "OK") {
            let result = results[0];
            this.draggedToAddress = result;
          }
        });
      })
    }
  }
};
</script>

<style scoped>
.gmaps-autocomplete {
  width: 100%;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
</style>
